module.exports = __webpack_public_path__ + "img/CY120026.cf88bda4.png";